/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentMethodDto {
    DEBIT_CHARGE = 'DEBIT_CHARGE',
    TRANSFER = 'TRANSFER',
}
